export const nextInput = event => {
  const form = event.target.form
  const index = Array.from(form.elements).indexOf(event.target)
  form.elements[index + 1]?.focus()
  event.preventDefault()
}
